import { connect } from "react-redux";
import { deleteSpecialCollection } from "../state/actions";
import SpecialCollectionDeleteModalComponent from "./SpecialCollectionDeleteModal";

const mapDispatchToProps = (dispatch) => ({
  deleteSpecialCollection: (specialCollectionPid) =>
    dispatch(deleteSpecialCollection(specialCollectionPid)),
});

export const SpecialCollectionDeleteModal = connect(
  null,
  mapDispatchToProps
)(SpecialCollectionDeleteModalComponent);
